import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { addColumn } from '../utils/schemas';
import { SelectWorkflowComponent } from './common/selectcomponent';
class GeomFromText extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.geomfromtext',
            group: 'Parsers',
            title: 'ST Geom from Text',
            description: `
      This component creates a new column with geometries created from the values
      in another column. This column should contain geometries defined in GeoJSON format.
      `
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'textcol',
                type: WorkflowComponentParamType.Column,
                title: 'Text column with geometries definition',
                parent: 'source',
                dataType: [ColumnDataType.String]
            }
        ]);
        this.supportedProviders = [Provider.Postgres, Provider.Redshift];
    }
    getInnerSql({ params, connection }) {
        switch (connection.type) {
            case Provider.Postgres:
            case Provider.Redshift:
                return dedent `SELECT
                  ST_GEOMFROMTEXT(${params.textcol})
                  AS ${params.textcol}_geo, *
                FROM ${connection.quoteName(params.source)}`;
            default:
                return null;
        }
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns, params }) {
        return addColumn(columns.source, {
            name: `${params.textcol}_geo`,
            type: ColumnDataType.Geometry
        });
    }
}
export { GeomFromText };
